import { render, staticRenderFns } from "./GRMDChart.vue?vue&type=template&id=e1f2b054"
import script from "./GRMDChart.vue?vue&type=script&lang=js"
export * from "./GRMDChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports